import * as React from 'react';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import { CircularProgress } from '@mui/material';
import { Theme } from '@mui/styles';
import * as request from 'superagent';
import Dropzone from '~common/components/versioned-document-dropzone';
//import * as Dropzone from 'react-dropzone/dist/index';
import { red, green, grey } from '@mui/material/colors';
import { Icon } from '@mui/material';
import {
  Button,
  IconButton,
  Checkbox,
  FormControl,
  FormControlLabel,
  TextField,
  FormHelperText
} from '@mui/material';
import PortalUserContext from '../lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    marginTop: '-3px'
  },
  document: {
    display: 'flex'
  },
  defaultDocument: {
    color: '#ccc'
  },
  deleteButton: {
    padding: 12
  },
  noDocument: {
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    fontWeight: 500,
    color: '#ccc',
    marginLeft: 15,
    marginTop: 7
  },
  documentIcon: {
    padding: 5,
    cursor: 'pointer'
  },
  documentFileName: {
    padding: 5,
    paddingRight: 10,
    marginTop: 5,
    cursor: 'pointer'
  },
  dropzone: {
    border: '1px dashed #ccc',
    padding: 15,
    marginLeft: 10,
    marginTop: 0,
    backgroundColor: grey[100],
    flex: 'auto',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer'
  },
  dropzoneMin: {
    border: '0px dashed #ccc',
    paddingTop: 8,
    marginLeft: 10,
    marginTop: 0,
    // backgroundColor: grey[100],
    width: '2rem',
    height: '2rem',
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center',
    cursor: 'pointer'
  },
  dropzoneActive: {
    backgroundColor: green[100]
  },
  dropzoneReject: {
    backgroundColor: red[100]
  },
  dropzoneDisabled: {
    backgroundColor: grey[400]
  },
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 44,
    minHeight: 44
  },
  listArea: {
    display: 'flex',
    alignContent: 'flex-start',
    alignItems: 'center'
  },
  subheader: {
    userSelect: 'none',
    lineHeight: 2.5,
    '&:focus': {
      outlineWidth: 0
    },
    backgroundColor: '#fff'
  },
  compactLabel: {
    fontSize: '0.75rem'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  dissallowNewVersions?: boolean;
  multiple?: boolean;
  preventDelete?: boolean;
  hideVersions?: boolean;
  suppressApiDelete?: boolean;
  alwaysOpenInNewWindow?: boolean;
  prompt?: string;
  noDocumentText?: string;
  accept?: string;
  url?: string;
  raw?: boolean; //returns the raw result after uploading.  Useful when uploading to the covert handler
  documents: any;
  maxSize?: number;
  minSize?: number;
  label?: string;
  error?: boolean;
  errorTextVal?: string;
  helperText?: string;
  onDocumentsChange: (versionedDocument: any) => void;
  onUploadError?: (err: string) => void;
  onFileReject?: (rejectedFiles: Array<any>) => void;
  minimal?: boolean;
  parse?: boolean;
  required?: boolean;
  fieldDefinition: any;
  hidePublicSelector?: boolean;
  onClick?: (fileName: string, storageKey: string, ea: any, newWindow?: boolean) => void;
}

type State = {
  prompt: string;
  accept: string;
  status: 'ready' | 'uploadingNewDocument' | 'uploaded';
  uploadingNewVersionIDX?: number;
  historyAnchorEl?: any;
  error?: any;
};

class DocumentList extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props);

    this.state = {
      status: 'ready',
      prompt: props.prompt || 'Drop file to upload new document',
      accept:
        props.accept ||
        'image/gif, image/jpeg, application/pdf, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, image/tiff, text/plain'
    };
  }

  onDrop = (acceptedFiles: Array<any>, rejectedFiles: Array<any>) => {
    const { parse } = this.props;
    if (rejectedFiles && rejectedFiles.length > 0 && this.props.onFileReject) {
      // console.log("rejecting files", rejectedFiles)
      this.props.onFileReject(rejectedFiles);
    }

    if (acceptedFiles && acceptedFiles.length > 0) {
      this.setState({ status: 'uploadingNewDocument' }, () => {
        const { documents } = this.props;

        let dl = documents;
        if (!dl || dl == "") {
          dl = {
            new: [],
            active: [],
            deleted: []
          };
        }
        // OK, we have one or more accepted files
        let parseFlag = '';
        if (parse) {
          parseFlag = '?parse=true';
        }
        for (let f of acceptedFiles) {
          request
            .post((this.props.url || `/api/attachment-storage`) + parseFlag)
            .attach(f.name, f)
            .then((response) => {
              if (response.ok) {

                const att = {
                  _id: new Date().getTime(),
                  fileName: f.name,
                  contentType: f.type,
                  size: f.size,
                  storageKey: response.body.storageKey,
                  pageCount: null,
                  createdAt: new Date(),
                  createdBy: PortalUserContext.userContext.displayName,
                  requireUserType: "Internal",
                  requireAccessToFeature: null,
                  extendedAttributes: {}
                };

                if (!dl.new) {
                  dl.new = []
                }

                dl.new.push(att)

                this.props.onDocumentsChange(dl);
                this.setState({ status: 'ready', error: null });
              } else {

                if (this.props.onUploadError) {
                  this.props.onUploadError(response.body);
                }

                // Report the error to the user
                this.setState({
                  status: 'ready',
                  error: 'An error occurred uploading the document'
                });
              }
            })
            .catch((err) => {
              if (this.props.onUploadError) {
                this.props.onUploadError(err);
              }
              // Report the error to the user
              this.setState({
                status: 'ready',
                error: 'An error occurred uploading the document'
              });
            });
        }
      });
    } else {
      this.setState({
        status: 'ready',
        error: 'Unacceptable file type selected.'
      })
    }
  };

  onDelete = (attachment: any, newWindow?: boolean) => (evt: any) => {
    const { documents } = this.props;

    let dl = documents;
    if (!dl || dl == "") {
      dl = {
        new: [],
        active: [],
        deleted: [],
      };
    }

    if (!dl.deleted) {
      dl.deleted = []
    }

    var deletedDoc
    if (attachment._id) {
      var idx = dl.new.findIndex((a: any) => { return a._id = attachment._id })
      if (idx > -1) {
        deletedDoc = dl.new[idx]
        dl.deleted.push(deletedDoc)
        dl.new.splice(idx, 1)
      }
    } else if (attachment.id) {
      var idx = dl.active.findIndex((a: any) => { return a.id = attachment.id })
      if (idx > -1) {
        deletedDoc = dl.active[idx]
        dl.deleted.push(deletedDoc)
        dl.active.splice(idx, 1)
      }
    }

    if (this.props.onDocumentsChange) {
      this.props.onDocumentsChange(dl);
    }
  };

  onClick = (fileName: string, storageKey: string, ea: any, newWindow?: boolean) => (
    evt: any
  ) => {
    if (this.props.onClick) {
      this.props.onClick(fileName, storageKey, ea, newWindow)
    } else {
      if (newWindow || this.props.alwaysOpenInNewWindow) {
        window.open(
          '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName,
          '_blank'
        );
      }
      else if (ea.source == "external") {
        // This route must be defined in client land.  This could become a property passed in
        window.open(`/api/${ea.source}/attachment/get/${storageKey}`)
      } else {
        window.location.href =
          '/api/attachment-storage/' + storageKey + '/raw?fileName=' + fileName;
      }
    }
  };

  handleShowHistory = (event: any) => {
    this.setState({ historyAnchorEl: event.currentTarget });
  };

  handleHistoryClose = () => {
    this.setState({ historyAnchorEl: null });
  };

  handleHistorySelect = (storageKey: string, newWindow?: boolean) => () => {
    if (newWindow || this.props.alwaysOpenInNewWindow) {
      window.open('/api/attachment-storage/' + storageKey + '/raw', '_blank');
    } else {
      window.location.href = '/api/attachment-storage/' + storageKey + '/raw';
    }
    this.setState({ historyAnchorEl: null });
  };

  onScopeChange = (attachment: any, evt: any) => {
    var { documents } = this.props


    if (attachment._id) {
      var idx = documents.new.findIndex((a: any) => { return a._id = attachment._id })
      if (idx > -1) {
        if (!documents.new[idx].requireUserType) {
          documents.new[idx].requireUserType = "Internal"
        } else {
          documents.new[idx].requireUserType = null
        }
      }
    } else if (attachment.id) {
      var idx = documents.active.findIndex((a: any) => { return a.id = attachment.id })
      if (idx > -1) {
        if (!documents.active[idx].requireUserType) {
          documents.active[idx].requireUserType = "Internal"
        } else {
          documents.active[idx].requireUserType = null
        }
      }
    }

    if (this.props.onDocumentsChange) {
      this.props.onDocumentsChange(documents);
    }
  }

  onAnnotationChange = (attachment: any, evt: any) => {
    var { documents } = this.props

    if (attachment._id) {
      var idx = documents.new.findIndex((a: any) => { return a._id = attachment._id })
      if (idx > -1) {
        documents.new[idx].extendedAttributes["annotation"] = evt.target.value
      }
    } else if (attachment.id) {
      var idx = documents.active.findIndex((a: any) => { return a.id = attachment.id })
      if (idx > -1) {
        documents.active[idx].extendedAttributes["annotation"] = evt.target.value
      }
    }

    if (this.props.onDocumentsChange) {
      this.props.onDocumentsChange(documents);
    }
  }

  getFileInfo = (
    mimeType: string,
    classes: any
  ): { iconClass: string; newWindow: boolean } => {
    var iconClass: any;
    var newWindow: boolean;

    switch (mimeType) {
      case 'image/gif':
      case 'image/jpeg':
      case 'image/tiff':
      case 'image/png':
        iconClass = 'fa-file-image ' + classes.icon;
        newWindow = true;
        break;
      case 'application/pdf':
        iconClass = 'fa-file-pdf ' + classes.icon;
        newWindow = true;

        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        iconClass = 'fa-file-word ' + classes.icon;
        newWindow = false;
        break;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.ms-excel':
        iconClass = 'fa-file-excel ' + classes.icon;
        newWindow = false;
        break;
      case 'text/plain':
        iconClass = 'fa-file-alt ' + classes.icon;
        newWindow = true;
        break;

      default:
        iconClass = 'fa-file ' + classes.icon;
        newWindow = false;
        break;
    }

    return { iconClass, newWindow };
  };

  render() {
    const { classes }: { classes: ClassNameMap } = this.props;
    const {
      minSize,
      maxSize,
      preventDelete,
      disabled,
      noDocumentText,
      fieldDefinition
    } = this.props;
    const { status, error } = this.state;

    var attachments
    if (this.props.documents && this.props.documents != "") {
      attachments = this.props.documents.active;
      if (!attachments) {
        attachments = []
      }
      if (this.props.documents.new) {
        attachments = attachments.concat(this.props.documents.new)
      }
    }

    let documentView = (
      <div className={classes.noDocument}>
        {noDocumentText || 'No document uploaded'}
      </div>
    );

    // console.log("fieldDefinition", fieldDefinition)
    if (attachments && attachments.length > 0) {
      documentView = (
        <div>
          {attachments.map((attachment: any, idx) => {

            const { iconClass, newWindow } = this.getFileInfo(
              attachment.contentType,
              classes
            );

            // console.log("Attachment", attachment)
            return (
              <div className={classes.document}>

                {!fieldDefinition.hidePublicSelector && <FormControl style={{ display: 'list-item', listStyle: 'none' }} component="fieldset">
                  <div style={{ width: '100%' }}>
                    <FormControlLabel
                      label="Public?"
                      control={
                        <Checkbox
                          checked={attachment.requireUserType != "Internal" ? true : false}
                          onChange={this.onScopeChange.bind(this, attachment)}
                          color="primary"
                          disabled={fieldDefinition.mode == 'Read Only'}
                        />
                      }
                    />
                  </div>
                </FormControl>}
                <TextField
                  // label="Title"
                  type={"text"}
                  value={attachment.extendedAttributes ? attachment.extendedAttributes["annotation"] : ""}
                  onChange={this.onAnnotationChange.bind(this, attachment)}
                  disabled={fieldDefinition.mode == 'Read Only'}
                />
                <Button
                  size="large"
                  color="inherit"
                  className={classes.documentFileName}
                  onClick={this.onClick(
                    attachment.fileName,
                    attachment.storageKey,
                    attachment.extendedAttributes,
                    newWindow
                  )}>
                  <i
                    className={'far ' + iconClass + ' ' + classes.documentIcon}
                    onClick={this.onClick(
                      attachment.fileName,
                      attachment.storageKey,
                      attachment.extendedAttributes,
                      newWindow
                    )}
                  />
                  {attachment.fileName}
                </Button>
                {!preventDelete && (
                  <IconButton
                    className={classes.deleteButton}
                    aria-label="delete"
                    size="large"
                    onClick={this.onDelete(attachment, newWindow)}>
                    <Icon>delete</Icon>
                  </IconButton>
                )}
              </div>
            )
          })}
        </div>
      )
    }

    var dropZone
    dropZone = (
      <Dropzone
        multiple={false}
        minSize={minSize}
        maxSize={maxSize}
        accept={this.state.accept}
        className={classes.dropzone}
        activeClassName={classes.dropzoneActive}
        rejectClassName={classes.dropzoneReject}
        disabledClassName={classes.dropzoneDisabled}
        onDrop={this.onDrop}
        disabled={this.props.disabled}>
        {(state: {
          isDragActive: boolean;
          isDragReject: boolean;
          acceptedFiles: Array<any>;
          rejectedFiles: Array<any>;
          draggedFiles: Array<any>;
        }) => {
          if (state.isDragReject) {
            if (state.rejectedFiles.length > 1 && !this.props.multiple) {
              return 'Multiple file drop is not permitted';
            } else {
              return 'This file is not acceptable';
            }
          }
          if (disabled && !attachments) {
            return 'Not Uploaded';
          }
          return this.state.prompt;
        }}
      </Dropzone>
    );


    if (status == "uploadingNewDocument") {
      dropZone = (
        <div className={classes.loading}>
          <CircularProgress color={'inherit'} size={20} thickness={3} />
        </div>
      );
    }

    var uploadError
    if (error) {
      uploadError = (<FormHelperText style={{ textAlign: 'center' }} error={true}>{error}</FormHelperText>)
    }

    var validationError
    if (this.props.error) {
      validationError = (<FormHelperText style={{ textAlign: 'center' }} error={true}>{this.props.errorTextVal}</FormHelperText>)
    }

    return (
      <div style={{ padding: 5, display: 'inline-block' }}>
        {dropZone}
        {uploadError}
        {validationError}
        {documentView}
      </div>

    )


  }
}

export default withStyles(styles)(DocumentList);
